import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";

/* Prop Types */
interface SortableItemProps {
  id: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * SortableItem
 * A generic sortable item for use with dnd-kit drag-and-drop.
 */
export const SortableItem = ({ id, className = "", children }: SortableItemProps) => {
  /* Hooks */
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  /* Styles */
  const transformStyles = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  /* Return */
  return (
    <div ref={setNodeRef} style={transformStyles} {...attributes} {...listeners} className={className}>
      {children}
    </div>
  );
};
